<template>
  <ElForm
    ref="slug"
    :rules="rules"
    label-position="top"
    :model="slugModel"
    @submit.native.prevent="submitUpdatedSlug"
  >
    <ElFormItem
      :label="$t('DEVELOPER_TITLES.REQUESTED_DEVELOPER_ID')"
      prop="requestedSlug"
    >
      <ElInput
        v-model="slugModel.requestedSlug"
        type="text"
        name="requestedSlug"
        dir="ltr"
        class="text-latin"
        required
      />
      <p class="el-form-item__help">
        {{ $t('DEVELOPER_TITLES.REQUESTED_DEVELOPER_ID_DESC') }}
      </p>

      <span slot="label">
        {{ $t('DEVELOPER_TITLES.REQUESTED_DEVELOPER_ID') }}
        <span
          v-if="slugModel.state"
          :class="[
            'chip',
            'chip--mini',
            'chip--aligned-middle',
            {
              'chip--warning': slugModel.state === 'N',
              'chip--alert': slugModel.state === 'R',
            },
          ]"
        >
          {{ $t(getStateTranslation(slugModel.state)) }}
        </span>
      </span>
    </ElFormItem>

    <ErrorsList
      v-if="requestedSlugFormErrors"
      :errors="requestedSlugFormErrors"
    />

    <div>
      <ElButton
        type="primary"
        :loading="updateSlugProcessing"
        @click.native="submitUpdatedSlug"
      >
        {{ $t('SAVE') }}
      </ElButton>
      <ElButton type="text" :plain="true" @click.native="$modal.close()">
        {{ $t('CANCEL') }}
      </ElButton>
    </div>

    <input v-show="false" type="submit" />
  </ElForm>
</template>

<script>
import form from '@/mixins/form';
import { DeveloperTitles } from '@/api/api';
import getStateTranslation from '@/utils/settings/getStateTranslation';
import required from '@/utils/validation-rules/required';

export default {
  name: 'EditDeveloperSlugModal',
  mixins: [form],
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    developer: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      slugModel: {
        requestedSlug: '',
      },
      updateSlugProcessing: false,
      requestedSlugFormErrors: null,
    };
  },
  computed: {
    rules() {
      return {
        requestedSlug: required(),
      };
    },
  },
  watch: {
    isOpen: {
      immediate: true,
      handler(open) {
        if (open) this.setInitialData();
        else this.reset();
      },
    },
  },
  methods: {
    getStateTranslation,
    setInitialData() {
      const { requestedSlug, state } = this.developer.slugChangeRequest || {};

      this.slugModel = {
        requestedSlug,
        state,
      };
    },
    updateDeveloperSlug() {
      this.updateSlugProcessing = true;
      const { id } = this.developer;

      return DeveloperTitles.updateSlug(
        { id },
        { requestedSlug: this.slugModel.requestedSlug },
      )
        .then(({ body: { message } }) => {
          this.$message.success(message);
          this.requestedSlugFormErrors = null;
          this.$modal.close(true);
        })
        .catch(({ body: { message, errors } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
          if (errors) {
            this.requestedSlugFormErrors = [...errors];
          }
        })
        .finally(() => {
          this.updateSlugProcessing = false;
        });
    },
    submitUpdatedSlug() {
      if (!this.isValid('slug')) {
        return false;
      }

      return this.updateDeveloperSlug();
    },
    reset() {
      this.resetForm('slug');
    },
  },
};
</script>
